<template>
  <v-row class="px-3 pt-1 mb-6" >
    <v-col cols="12" sm="12" md="12">
      <v-card>
        <v-card-title>
          Transcriptions 
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table v-if="listTranscriptions"
          :items-per-page="10"
          :headers="headers"
          :items="listTranscriptions"
          :search="search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template v-slot:[`item.transc_id`]="{ item }">
            <span><a style="color: black; text-decoration: underline;" :href="'https://console.firebase.google.com/project/transcriber-vito/firestore/data/~2Ftranscripts~2F' + item.transc_id" target="_blank">{{ item.transc_id }}</a></span>
          </template>
          <template v-slot:[`item.transc_timestamp`]="{ item }">
            <span>{{formatDate(item.transc_timestamp)}}</span>
          </template>
          <template v-slot:[`item.transc_audioDuration`]="{ item }">
            <span>{{formatLength(item.transc_audioDuration)}}</span>
          </template>
        </v-data-table>
      </v-card> 
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { getOrgStats } from "../../plugins/getAnalysics";
import moment from "moment";

export default {
  name: "OrgDetailData",

  data() {
    return {
      // table settings
      search: '',
      headers: [
        {
          text: 'transc_id',
          align: 'start',
          // filterable: false,
          value: 'transc_id',
        },
        { text: 'user_email', value: 'user_email' },
        { text: 'time (min)', value: 'transc_audioDuration' },
        { text: 'date', value: 'transc_timestamp' },
        { text: 'lang', value: 'transc_languageCodes' },
        { text: 'status', value: 'transc_status' },
      ],
      sortBy: 'transc_timestamp',
      sortDesc: true,

      // data
      listTranscriptions: null,
    };
  },

  props: {
    orgId: {
      default: () => ({})
    },
    userId: {
      default: () => ({})
    },
  },

  computed: {
    ...mapGetters({
      datesrange: "datesrange",
    }),
  },
 
  methods: {
    formatDate(date){
      // let a = moment(new Date(date.value)).format("DD/MM/YYYY")
      let a = moment(new Date(date)).format("DD/MM/YYYY")
      return a
    },
    formatLength(value) {
      let a = (value / 60).toFixed(0)
      return a
    },
    async getTranscriptionsLists(){
      const listTranscriptions = await getOrgStats({ queryType: 'listTranscriptions', orgId: this.orgId, userId: this.userId, datesrange: this.datesrange })
      this.listTranscriptions = listTranscriptions.data
      // console.log('&&&&&')
      // console.log(listTranscriptions)
      // console.log(this.listTranscriptions[0].transc_timestamp)
      // if(this.orgId != ''){
        
      // } else {
      //   const listOrgTranscriptions = await getOrgStats({ queryType: 'listTranscriptions', datesrange: this.datesrange })
      //   this.listTranscriptions = listOrgTranscriptions.data
      // }
    },
  },
 
  async mounted(){
    this.getTranscriptionsLists();
  },

}
</script>

<style>

</style>